import React from "react";
import {
  render as rtlRender,
  getByText,
  findByText,
  fireEvent,
  waitForElement,
} from "@testing-library/react";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
// Import your own reducer
import accountReducer from "../../features/accounts/Login/accountSlice";
import forgotPasswordReducer from "../../features/accounts/TroubleLogin/forgotPasswordSlice";
import forgotUserReducer from "../../features/accounts/TroubleLogin/forgotUserSlice";
import resetPasswordReducer from "../../features/accounts/TroubleLogin/resetPasswordSlice";
import setPasswordReducer from "../../features/accounts/SetPassword/setPasswordSlice";
import userReducer from "../../features/LandingPage/userSlice";
import addUserReducer from "../../features/LandingPage/AddUser/addUserSlice";
import contactSlice from "../../features/accounts/TroubleLogin/contactSlice";
import updateUserReducer from "../../features/LandingPage/UpdateUser/updateUserSlice";
import addFacilitiesReducer from "../../features/LandingPage/FacilityAddEdit/AddFacilitySlice";
import updateFacilityReducer from "../../features/LandingPage/FacilityAddEdit/UpdateFacilitySlice";
import addHospitalsReducer from "../../features/LandingPage/HospitalAddEdit/AddHospitalSlice";
import addLabsReducer from "../../features/LandingPage/LabAddEdit/AddLabSlice";
import updateHospitalReducer from "../../features/LandingPage/HospitalAddEdit/UpdateHospitalSlice";
import updateLabReducer from "../../features/LandingPage/LabAddEdit/UpdateLabSlice";
import addStatOrdersReducer from "../../features/StatOrder/addStatOrderSlice";
import updateStatOrdersReducer from "../../features/StatOrder/updateStatOrderSlice";

function render(
  ui,
  {
    preloadedState,
    store = configureStore({
      reducer: {
        account: accountReducer,
        forgotPassword: forgotPasswordReducer,
        forgotUser: forgotUserReducer,
        resetPassword: resetPasswordReducer,
        setPass: setPasswordReducer,
        users: userReducer,
        addUser: addUserReducer,
        updateUser: updateUserReducer,
        contact: contactSlice,
        addFacilities: addFacilitiesReducer,
        updateFacility: updateFacilityReducer,
        updateHospital: updateHospitalReducer,
        addHospitals: addHospitalsReducer,
        updateLab: updateLabReducer,
        addLabs: addLabsReducer,
        addStatOrders: addStatOrdersReducer,
        updateStatOrders: updateStatOrdersReducer,
      },
      preloadedState,
    }),
    ...renderOptions
  } = {}
) {
  function Wrapper({ children }) {
    return <Provider store={store}>{children}</Provider>;
  }
  return rtlRender(ui, { wrapper: Wrapper, ...renderOptions });
}

// re-export everything
export * from "@testing-library/react";
// override render method
export { render };

export function phoneFormat(input) {
  input = input.replace(/\D/g, "").substring(0, 10); //Strip everything but 1st 10 digits
  var size = input.length;
  if (size > 0) {
    input = "(" + input;
  }
  if (size > 3) {
    input = input.slice(0, 4) + ") " + input.slice(4);
  }
  if (size > 6) {
    input = input.slice(0, 9) + "-" + input.slice(9);
  }

  return input;
}
